module.exports = __webpack_public_path__ + "img/3.5505c890.jpg";